import {
  Button,
  Card,
  CircularProgress,
  Grid,
  Hidden,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@material-ui/core";
import {
  AddOutlined,
  InfoOutlined,
  VisibilityOutlined,
} from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useCallback } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";

import {
  ModalDetails,
  ModalFacilityAround,
  ModalPreviewSec,
  ModalUnit,
  TableDetails,
  TableFacilityAround,
  TableUnit,
  UploadImage,
} from "../../../components";
import { getTipeAset } from "../../../redux/actions/AsetInvestasiActions";
import { getKota } from "../../../redux/actions/KotaActions";
import {
  getDetailPortfolio,
  updPortfolio,
} from "../../../redux/actions/PortfolioActions";
import { getTipePropDev } from "../../../redux/actions/PropertyDevelopmentActions";
import { getProvinsi } from "../../../redux/actions/ProvinsiActions";

const EditPortfolio = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const [submit, setSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPreviewSec, setShowPreviewSec] = useState(null);
  const { tipe: tipeAset } = useSelector(({ asetInvest }) => asetInvest);
  const { tipe: tipePropDev } = useSelector(({ propertyDev }) => propertyDev);
  const [showFoto, setShowFoto] = useState(false);
  const [foto, setFoto] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [details, setDetails] = useState(null);
  const [showFacilities, setShowFacilities] = useState(false);
  const [facilities, setFacilities] = useState(null);
  const { provinsi } = useSelector(({ provinsi }) => provinsi);
  const { kota } = useSelector(({ kota }) => kota);
  const [params, setParams] = useState({
    hero_desktop: "",
    hero_desktop_preview: "",
    hero_desktop_ori: "",
    hero_mobile: "",
    hero_mobile_preview: "",
    hero_mobile_ori: "",
    title_id: "",
    title_en: "",
    kind: "",
    type_code: "",
    address: "",
    lat: "",
    lng: "",
    desc_id: "",
    desc_en: "",
    bg_img: "",
    bg_img_preview: "",
    bg_img_ori: "",
    video_link: "",
    details: [],
    facilities: [],
    image: [],
    bg_video: "",
    bg_video_preview: "",
    bg_video_ori: "",
    portfolio_code: "",
    province_code: "",
    city_code: "",
  });
  useEffect(() => {
    dispatch(getTipeAset({ paginate: false }));
    dispatch(getTipePropDev({ paginate: false }));
    dispatch(getProvinsi({ paginate: false }));
  }, [dispatch]);
  const handleChange = ({ target: { value, name } }) => {
    if (name === "kind") {
      setParams((pref) => ({
        ...pref,
        type_code: "",
      }));
    }
    if (name === "province_code") {
      setParams((pref) => ({
        ...pref,
        city_code: "",
      }));
      dispatch(getKota({ paginate: false, province_code: value }));
    }
    setParams((pref) => ({
      ...pref,
      [name]: value,
    }));
  };
  const handleFormSubmit = () => {
    setSubmit(true);
    updPortfolio(params)
      .then(() => {
        showAlert("Data berhasil disimpan", true);
        setSubmit(false);
      })
      .catch((err) => {
        let error = err?.response?.data;
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal menyimpan data, coba beberapa saat lagi",
          false
        );
        setSubmit(false);
      });
  };
  const showAlert = useCallback(
    (text, success) => {
      Swal.fire({
        title: success ? "Berhasil" : "Oopss!",
        text: text,
        imageUrl: `/assets/images/icons/${
          success ? "ic_success" : "ic_error"
        }.svg`,
        imageWidth: 92,
        imageHeight: 92,
        confirmButtonText: "Ok",
        confirmButtonColor: "#0083E2",
      }).then((res) => {
        if (res.isConfirmed && success) {
          history.goBack();
        }
      });
    },
    [history]
  );
  const handleChangeFoto = (name, file) => {
    setParams((pref) => ({
      ...pref,
      [name]: file,
      [name + "_preview"]: file,
    }));
  };
  const getData = useCallback(() => {
    setLoading(true);
    getDetailPortfolio(id)
      .then((res) => {
        let data = res.data?.data;
        if (Object.keys(data).length > 0) {
          dispatch(
            getKota({ paginate: false, province_code: data?.province_code })
          );
          setParams((pref) => ({
            ...pref,
            hero_desktop: "",
            hero_desktop_preview: data?.hero_desktop,
            hero_desktop_ori: data?.hero_desktop_ori,
            hero_mobile: "",
            hero_mobile_preview: data?.hero_mobile,
            hero_mobile_ori: data?.hero_mobile_ori,
            title_id: data?.title_id,
            title_en: data?.title_en,
            kind: data?.kind,
            type_code: data?.type_code,
            address: data?.address,
            lat: data?.lat,
            lng: data?.lng,
            desc_id: data?.desc_id,
            desc_en: data?.desc_en,
            bg_img: "",
            bg_img_preview: data?.bg_img,
            bg_img_ori: data?.bg_img_ori,
            video_link: data?.video_link,
            details: data?.details,
            facilities: data?.facilities,
            image: data?.port_img,
            bg_video: "",
            bg_video_preview: data?.bg_video,
            bg_video_ori: data?.bg_video_ori,
            portfolio_code: data?.portfolio_code,
            province_code: data?.province_code,
            city_code: data?.city_code,
          }));
        } else {
          showAlert(
            "Gagal mengambil detail data, coba beberapa saat lagi",
            false
          );
        }
        setLoading(false);
      })
      .catch((err) => {
        let error = err?.response?.data;
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal mengambil detail data, coba beberapa saat lagi",
          false
        );
        setLoading(false);
      });
  }, [id, showAlert, dispatch]);
  useEffect(() => {
    setParams((pref) => ({
      ...pref,
      portfolio_code: id,
    }));
    getData();
  }, [getData, id]);
  const handleSaveDetails = (data) => {
    if (data?.idx) {
      let cek = params.details.findIndex((item) => item.idx === data.idx);
      let details = params.details;
      details[cek].title_id = data.title_id;
      details[cek].title_en = data.title_en;
      details[cek].desc_id = data.desc_id;
      details[cek].desc_en = data.desc_en;
      setParams((pref) => ({
        ...pref,
        details: [...details],
      }));
      setShowDetails(false);
    } else {
      let newDetails = {
        ...data,
        idx: Math.floor(Math.random() * 100),
      };
      setParams((pref) => ({
        ...pref,
        details: [...pref.details, newDetails],
      }));
      setShowDetails(false);
    }
    setDetails(null);
  };
  const handleDelDetails = (idx) => {
    let newDetails = params.unit.filter((item) => item.idx !== idx);
    setParams((pref) => ({
      ...pref,
      details: newDetails,
    }));
  };
  const handleSaveFoto = (data) => {
    if (data?.idx) {
      let cek = params.image.findIndex((item) => item.idx === data.idx);
      let image = params.image;
      image[cek].img = data?.img ? data.img : image[cek].img;
      image[cek].title_id = data.title_id;
      image[cek].title_en = data.title_en;
      image[cek].desc_id = data.desc_id;
      image[cek].desc_en = data.desc_en;
      setParams((pref) => ({
        ...pref,
        image: [...image],
      }));
      setShowFoto(false);
    } else {
      let newFoto = {
        ...data,
        idx: Math.floor(Math.random() * 100),
      };
      setParams((pref) => ({
        ...pref,
        image: [...pref.image, newFoto],
      }));
      setShowFoto(false);
    }
    setFoto(null);
  };
  const handleDelFoto = (idx) => {
    let newFoto = params.image.filter((item) => item.idx !== idx);
    setParams((pref) => ({
      ...pref,
      image: newFoto,
    }));
  };
  const handleSaveFacilities = (data) => {
    if (data?.idx) {
      let cek = params.facilities.findIndex((item) => item.idx === data.idx);
      let facilities = params.facilities;
      facilities[cek].icon = data?.icon ? data.icon : facilities[cek].icon;
      facilities[cek].title_id = data.title_id;
      facilities[cek].title_en = data.title_en;
      facilities[cek].range = data.range;
      setParams((pref) => ({
        ...pref,
        facilities: [...facilities],
      }));
      setShowFacilities(false);
    } else {
      let newFacilities = {
        ...data,
        idx: Math.floor(Math.random() * 100),
      };
      setParams((pref) => ({
        ...pref,
        facilities: [...pref.facilities, newFacilities],
      }));
      setShowFacilities(false);
    }
    setFacilities(null);
  };
  const handleDelFacilities = (idx) => {
    let newFacilities = params.facilities.filter((item) => item.idx !== idx);
    setParams((pref) => ({
      ...pref,
      facilities: newFacilities,
    }));
  };
  return (
    <div className="m-sm-30">
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={11} md={12}>
          <h3 className="fw-bold m-0">Edit Data</h3>
        </Grid>
        <Grid item xs={11} md={12}>
          <Card elevation={0} className="py-5 px-6 border-radius-0 ">
            {loading ? (
              <div className="text-center">
                <CircularProgress color="primary" size={35} />
              </div>
            ) : (
              <ValidatorForm onSubmit={handleFormSubmit} className="w-full">
                <Grid container spacing={2}>
                  {/* Data Portfolio */}
                  <Grid item xs={12} md={6}>
                    <UploadImage
                      uploadFoto={(file) =>
                        handleChangeFoto("hero_desktop", file)
                      }
                      label="Unggah Foto Untuk Desktop"
                      preview={params?.hero_desktop_preview}
                      required={true}
                      noCrop={true}
                      note={[
                        "Format PNG, WEBP dan JPG diperbolehkan",
                        "*Ukuran foto 1440 x 617",
                      ]}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <UploadImage
                      uploadFoto={(file) =>
                        handleChangeFoto("hero_mobile", file)
                      }
                      label="Unggah Foto Untuk Mobile"
                      preview={params?.hero_mobile_preview}
                      noCrop={true}
                      required={true}
                      note={[
                        "Format PNG, WEBP dan JPG diperbolehkan",
                        "*Ukuran foto 767 x 500",
                      ]}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <UploadImage
                      uploadFoto={(file) => handleChangeFoto("bg_img", file)}
                      label="Unggah Foto Portfolio"
                      preview={params?.bg_img_preview}
                      noCrop={true}
                      required={true}
                      note={[
                        "Format PNG, WEBP dan JPG diperbolehkan",
                        "*Ukuran foto 772 x 579",
                      ]}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel htmlFor="title_id" className="mb-4">
                      Judul [ID] <span className="text-danger">*</span>
                      <Tooltip
                        title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                        placement="top-start"
                        arrow
                      >
                        <InfoOutlined
                          fontSize="small"
                          color="action"
                        ></InfoOutlined>
                      </Tooltip>
                    </InputLabel>
                    <TextValidator
                      id="title_id"
                      placeholder="Judul"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="title_id"
                      value={params.title_id || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Judul terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel htmlFor="title_en" className="mb-4">
                      Judul [EN] <span className="text-danger">*</span>
                      <Tooltip
                        title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                        placement="top-start"
                        arrow
                      >
                        <InfoOutlined
                          fontSize="small"
                          color="action"
                        ></InfoOutlined>
                      </Tooltip>
                    </InputLabel>
                    <TextValidator
                      id="title_en"
                      placeholder="Judul"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="title_en"
                      value={params.title_en || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Judul terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel htmlFor="kind" className="mb-4">
                      Jenis Properti <span className="text-danger">*</span>
                    </InputLabel>
                    <Select
                      labelId="kind"
                      value={params.kind}
                      onChange={handleChange}
                      variant="outlined"
                      className="w-full"
                      name="kind"
                      displayEmpty
                    >
                      <MenuItem value="" selected disabled>
                        Pilih Jenis Properti
                      </MenuItem>
                      <MenuItem value="development">
                        Property Development
                      </MenuItem>
                      <MenuItem value="asset">
                        Aset & Investasi property
                      </MenuItem>
                      <MenuItem value="hotel">Hotel</MenuItem>
                    </Select>
                  </Grid>
                  {params.kind === "development" ? (
                    <Grid item xs={12} md={6}>
                      <InputLabel htmlFor="type_code" className="mb-4">
                        Tipe Property Development{" "}
                        <span className="text-danger">*</span>
                      </InputLabel>
                      <Select
                        labelId="type_code"
                        value={params.type_code}
                        onChange={handleChange}
                        variant="outlined"
                        className="w-full"
                        name="type_code"
                        displayEmpty
                      >
                        <MenuItem value="" selected disabled>
                          Pilih Tipe Property Development
                        </MenuItem>
                        {tipePropDev?.map((item) => (
                          <MenuItem value={item.type_code} key={item.type_code}>
                            {item.type_id}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                  ) : params.kind === "asset" ? (
                    <Grid item xs={12} md={6}>
                      <InputLabel htmlFor="type_code" className="mb-4">
                        Tipe Aset & Investasi Properti{" "}
                        <span className="text-danger">*</span>
                      </InputLabel>
                      <Select
                        labelId="type_code"
                        value={params.type_code}
                        onChange={handleChange}
                        variant="outlined"
                        className="w-full"
                        name="type_code"
                        displayEmpty
                      >
                        <MenuItem value="" selected disabled>
                          Pilih Tipe Aset & Investasi Properti
                        </MenuItem>
                        {tipeAset?.map((item) => (
                          <MenuItem value={item.type_code} key={item.type_code}>
                            {item.type_id}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                  ) : null}
                  <Grid item xs={12} md={6}>
                    <InputLabel htmlFor="province_code" className="mb-4">
                      Provinsi <span className="text-danger">*</span>
                    </InputLabel>
                    <Select
                      size="small"
                      labelId="province_code"
                      value={params.province_code}
                      onChange={handleChange}
                      variant="outlined"
                      className="w-full"
                      name="province_code"
                      displayEmpty
                    >
                      <MenuItem value="" selected>
                        Pilih Provinsi
                      </MenuItem>
                      {provinsi?.map((item) => (
                        <MenuItem
                          value={item.province_code}
                          key={item.province_code}
                        >
                          {item.province_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel htmlFor="city_code" className="mb-4">
                      Kota <span className="text-danger">*</span>
                    </InputLabel>
                    <Select
                      size="small"
                      labelId="city_code"
                      value={params.city_code}
                      onChange={handleChange}
                      variant="outlined"
                      className="w-full"
                      name="city_code"
                      displayEmpty
                    >
                      <MenuItem value="" selected>
                        Pilih Kota
                      </MenuItem>
                      {kota?.map((item) => (
                        <MenuItem value={item.city_code} key={item.city_code}>
                          {item.city_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel htmlFor="address" className="mb-4">
                      Alamat <span className="text-danger">*</span>
                    </InputLabel>
                    <TextValidator
                      id="address"
                      placeholder="Alamat Properti"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="address"
                      value={params.address || ""}
                      validators={["required"]}
                      errorMessages={[
                        "Masukkan Alamat Properti terlebih dahulu",
                      ]}
                      multiline
                      maxRows={5}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel htmlFor="lat" className="mb-4">
                      Latitude <span className="text-danger">*</span>
                    </InputLabel>
                    <TextValidator
                      id="lat"
                      placeholder="Latitude Alamat Properti"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="lat"
                      value={params.lat || ""}
                      validators={["required"]}
                      errorMessages={[
                        "Masukkan Latitude Alamat Properti terlebih dahulu",
                      ]}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel htmlFor="lng" className="mb-4">
                      Longitude <span className="text-danger">*</span>
                    </InputLabel>
                    <TextValidator
                      id="lng"
                      placeholder="Longitude Alamat Properti"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="lng"
                      value={params.lng || ""}
                      validators={["required"]}
                      errorMessages={[
                        "Masukkan Longitude Alamat Properti terlebih dahulu",
                      ]}
                    />
                  </Grid>
                  {/* Bagian 1 */}
                  <Grid item xs={12} className="mt-6">
                    <h4 className="font-semibold">
                      Bagian 1{" "}
                      <IconButton
                        onClick={() =>
                          setShowPreviewSec(
                            "/assets/images/illustrations/portfolio_1.png"
                          )
                        }
                        size="small"
                      >
                        <VisibilityOutlined
                          fontSize="small"
                          color="action"
                        ></VisibilityOutlined>
                      </IconButton>
                    </h4>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel htmlFor="desc_id" className="mb-4">
                      Deskripsi [ID] <span className="text-danger">*</span>
                      <Tooltip
                        title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                        placement="top-start"
                        arrow
                      >
                        <InfoOutlined
                          fontSize="small"
                          color="action"
                        ></InfoOutlined>
                      </Tooltip>
                    </InputLabel>
                    <TextValidator
                      id="desc_id"
                      placeholder="Deskripsi"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="desc_id"
                      value={params.desc_id || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Deskripsi terlebih dahulu"]}
                      multiline
                      maxRows={16}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel htmlFor="desc_en" className="mb-4">
                      Deskripsi [EN] <span className="text-danger">*</span>
                      <Tooltip
                        title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                        placement="top-start"
                        arrow
                      >
                        <InfoOutlined
                          fontSize="small"
                          color="action"
                        ></InfoOutlined>
                      </Tooltip>
                    </InputLabel>
                    <TextValidator
                      id="desc_en"
                      placeholder="Deskripsi"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="desc_en"
                      value={params.desc_en || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Deskripsi terlebih dahulu"]}
                      multiline
                      maxRows={16}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <UploadImage
                      uploadFoto={(file) => handleChangeFoto("bg_video", file)}
                      label="Unggah Foto Thumbnail Video"
                      preview={params?.bg_video_preview}
                      noCrop={true}
                      required={true}
                      note={[
                        "Format PNG, WEBP dan JPG diperbolehkan",
                        "*Ukuran foto 1024 x 1160",
                      ]}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel htmlFor="video_link" className="mb-4">
                      URL Video
                      <span className="text-danger">*</span>
                    </InputLabel>
                    <TextValidator
                      id="video_link"
                      placeholder="Judul"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="video_link"
                      value={params.video_link || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Judul terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={6} md={10} className="flex items-center">
                    <h5 className="font-semibold">
                      Data{" "}
                      <IconButton
                        onClick={() =>
                          setShowPreviewSec(
                            "/assets/images/illustrations/portfolio_2.png"
                          )
                        }
                        size="small"
                      >
                        <VisibilityOutlined
                          fontSize="small"
                          color="action"
                        ></VisibilityOutlined>
                      </IconButton>
                    </h5>
                  </Grid>
                  <Grid item xs={6} md={2} className="flex items-center gap-4">
                    <Hidden xsDown>
                      <Button
                        onClick={() => setShowDetails(true)}
                        type="button"
                        variant="contained"
                        color="primary"
                        className="text-white w-full text-capitalize"
                        disableElevation
                      >
                        <AddOutlined />
                        Tambah
                      </Button>
                    </Hidden>
                    <Hidden smUp>
                      <Button
                        onClick={() => setShowDetails(true)}
                        type="button"
                        variant="contained"
                        color="primary"
                        className="text-white w-full text-capitalize"
                        disableElevation
                        size="small"
                      >
                        <AddOutlined />
                      </Button>
                    </Hidden>
                  </Grid>
                  <Grid item xs={12}>
                    <TableDetails
                      data={params.details}
                      handleDelDetails={handleDelDetails}
                      setDetails={setDetails}
                      setShowDetails={setShowDetails}
                    />
                  </Grid>
                  {/* Bagian 2 */}
                  <Grid item xs={6} md={10} className="flex items-center">
                    <h4 className="font-semibold">
                      Bagian 2{" "}
                      <IconButton
                        onClick={() =>
                          setShowPreviewSec(
                            "/assets/images/illustrations/portfolio_3.png"
                          )
                        }
                        size="small"
                      >
                        <VisibilityOutlined
                          fontSize="small"
                          color="action"
                        ></VisibilityOutlined>
                      </IconButton>
                    </h4>
                  </Grid>
                  <Grid item xs={6} md={2} className="flex items-center gap-4">
                    <Hidden xsDown>
                      <Button
                        onClick={() => setShowFoto(true)}
                        type="button"
                        variant="contained"
                        color="primary"
                        className="text-white w-full text-capitalize"
                        disableElevation
                      >
                        <AddOutlined />
                        Tambah
                      </Button>
                    </Hidden>
                    <Hidden smUp>
                      <Button
                        onClick={() => setShowFoto(true)}
                        type="button"
                        variant="contained"
                        color="primary"
                        className="text-white w-full text-capitalize"
                        disableElevation
                        size="small"
                      >
                        <AddOutlined />
                      </Button>
                    </Hidden>
                  </Grid>
                  <Grid item xs={12}>
                    <TableUnit
                      data={params.image}
                      handleDelUnit={handleDelFoto}
                      setShowUnit={setShowFoto}
                      setUnit={setFoto}
                    />
                  </Grid>
                  {/* Fasilitas */}
                  <Grid item xs={6} md={10} className="flex items-center">
                    <h4 className="font-semibold">
                      Fasilitas Sekitar{" "}
                      <IconButton
                        onClick={() =>
                          setShowPreviewSec(
                            "/assets/images/illustrations/portfolio_4.png"
                          )
                        }
                        size="small"
                      >
                        <VisibilityOutlined
                          fontSize="small"
                          color="action"
                        ></VisibilityOutlined>
                      </IconButton>
                    </h4>
                  </Grid>
                  <Grid item xs={6} md={2} className="flex items-center gap-4">
                    <Hidden xsDown>
                      <Button
                        onClick={() => setShowFacilities(true)}
                        type="button"
                        variant="contained"
                        color="primary"
                        className="text-white w-full text-capitalize"
                        disableElevation
                      >
                        <AddOutlined />
                        Tambah
                      </Button>
                    </Hidden>
                    <Hidden smUp>
                      <Button
                        onClick={() => setShowFacilities(true)}
                        type="button"
                        variant="contained"
                        color="primary"
                        className="text-white w-full text-capitalize"
                        disableElevation
                        size="small"
                      >
                        <AddOutlined />
                      </Button>
                    </Hidden>
                  </Grid>
                  <Grid item xs={12}>
                    <TableFacilityAround
                      data={params.facilities}
                      handleDelFasilitas={handleDelFacilities}
                      setFasilitas={setFacilities}
                      setShowFasilitas={setShowFacilities}
                    />
                  </Grid>
                  {/* Tombol */}
                  <Grid item xs={12}>
                    <Grid
                      container
                      spacing={2}
                      justifyContent="flex-end"
                      className="flex-column-reverse flex-md-row"
                    >
                      <Grid item xs={12} md={2}>
                        <Button
                          color="primary"
                          className="text-primary w-full radius-6 text-capitalize py-2"
                          disableElevation
                          disabled={submit}
                          onClick={() => history.goBack()}
                        >
                          Batal
                        </Button>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          className="text-white w-full radius-6 text-capitalize py-2"
                          disableElevation
                          disabled={submit}
                        >
                          {submit ? (
                            <CircularProgress color="primary" size={25} />
                          ) : (
                            "Simpan"
                          )}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </ValidatorForm>
            )}
          </Card>
        </Grid>
      </Grid>
      {showPreviewSec && (
        <ModalPreviewSec
          handleClose={() => setShowPreviewSec(null)}
          img={showPreviewSec}
          open={showPreviewSec}
        />
      )}
      {showDetails && (
        <ModalDetails
          data={details}
          handleClose={() => {
            setShowDetails(false);
            setDetails(null);
          }}
          handleSave={handleSaveDetails}
          open={showDetails}
        />
      )}
      {showFoto && (
        <ModalUnit
          data={foto}
          handleClose={() => {
            setShowFoto(false);
            setFoto(null);
          }}
          handleSave={handleSaveFoto}
          open={showFoto}
          judul="Data"
        />
      )}
      {showFacilities && (
        <ModalFacilityAround
          data={facilities}
          handleClose={() => {
            setShowFacilities(false);
            setFacilities(null);
          }}
          handleSave={handleSaveFacilities}
          open={showFacilities}
        />
      )}
    </div>
  );
};

export default EditPortfolio;
